import React from "react";
import sanitizeHtml from "sanitize-html";

function HtmlRenderer({ html }) {
  // sanitize-html options: allow common tags & attributes
  const cleanHTML = sanitizeHtml(html, {
  allowedTags: [
    "h1", "h2", "h3", "p", "strong", "em", "u", "a", "ul", "ol", "li", "i",
    "img", "iframe", "br", "span", "div"
  ],
  allowedAttributes: {
    a: ["href", "target", "rel", "class"],
    img: ["src", "alt", "title", "width", "height", "style", "class"],
    iframe: [
      "src", "width", "height", "frameborder",
      "allow", "allowfullscreen", "title", "class"
    ],
    div: ["class"],
    span: ["class"],
    "*": ["style", "class"], // allow inline styles + classes globally
  },
  allowedIframeHostnames: ["www.youtube.com", "youtube.com", "player.vimeo.com"],
});

  return <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />;
}

export default HtmlRenderer;